import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, viewChild, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AliceDateSeletorComponent } from "../../../Shared/stepper/address/AliceDateSeletor/AliceDateSeletor.component";
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { StepperModule } from 'primeng/stepper';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CreateOrdreRequest, Direction, IOrderLinesCreateOrder, itemStock, itemStockDetails, OrderLines, OrderServices, Statuses, WarehouseService } from 'src/app/services/warehouse.service';
import { AsyncPipe, CommonModule } from '@angular/common';
import { AddressService } from 'src/app/services/address.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TranslatePipe } from '@ngx-translate/core';
import { Address } from 'src/app/domain/Address';
import { Table, TableModule, TableSelectAllChangeEvent } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { AccordionModule } from 'primeng/accordion';
import { CustomerService } from 'src/app/services/customer.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, catchError, forkJoin, of, Subscription } from 'rxjs';
import { DividerModule } from "primeng/divider";

@Component({
  selector: 'app-warehouse-create-order-modal',
  standalone: true,
  imports: [
    CommonModule,
    AliceDateSeletorComponent,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    StepperModule,
    InputTextModule,
    FloatLabelModule,
    AsyncPipe,
    TranslatePipe,
    AutoCompleteModule,
    CheckboxModule,
    TableModule,
    AccordionModule,
    DividerModule
  ],
  templateUrl: "warehouseCreateOrderModal.component.html",
  styleUrls: ['warehouseCreateOrderModal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class WarehouseCreateOrderModalComponent implements AfterViewInit {

  itemStocks$ = new BehaviorSubject<itemStock[]>(new Array<itemStock>());
  foundAddresses: any;
  foundCustomers: any;
  contactPersons: any[];
  @ViewChild('addressStreet') addressStreet: HTMLElement;
  @ViewChild('dt2') dt2: Table;
  itemStockDetails$ = this.warehouseService.itemStockDetails$;
  filteredItemStocks: itemStock[] = [];
  addressSearchSubscription = new Subscription();
  selectedProducts = [];
  IsShowSelectedItems = false;

  //#region dateselector prop
  minDate = new Date("01/01/1970");
  startDate = this.buildStartDate();
  endDate = new Date();
  //#endregion

  //#region adressForm
  adresseForm = new FormControl();
  SelectedAdresseObject = new FormGroup({
    countryCode: new FormControl(),
    city: new FormControl(null, Validators.required),
    street: new FormControl(null, Validators.required),
    zipCode: new FormControl(null, Validators.required),
    latitude: new FormControl(),
    longitude: new FormControl(),
    customerObject: new FormControl(),
  });
  //#endregion

  //#region ordreCreation
  orderForm = new FormGroup({
    orderNumber: new FormControl(),
    deliveryDate: new FormControl(new Date()),
    catalogItem: new FormControl(),
    customerObject: new FormControl(),
    address: new FormControl(),
    zip: new FormControl(),
    city: new FormControl(),
    openingHours: new FormControl(),
    note: new FormControl(),
    CustomerName: new FormControl()
  });

  deliveryInfomationFormGroup = new FormGroup({
    deliveryDate: new FormControl(new Date(), Validators.required),
    deliveryOrderNo: new FormControl(""),
    deliveryNote: new FormControl(""),
    deliveryName: new FormControl(null),
    deliveryContactPerson: new FormControl(""),
    deliveryContactEmail: new FormControl(""),
    deliveryContactPhone: new FormControl(""),
  })
  catalogItems = new Array<string>();
  //#endregion



  constructor(private warehouseService: WarehouseService, private addressService: AddressService, private customerService: CustomerService, public ref: DynamicDialogRef) {
    // this.SelectedAdresseObject.disable();
    this.itemStocks$.next(new Array());
    this.warehouseService.itemStocks$.subscribe(x => {
      this.itemStocks$.next(x.filter(x => !x.isDeleted));
    })
    this.warehouseService.itemStockDetails$.subscribe(x => {
      x.forEach(y => y.changeAmountOnPallet = y.amountOnPallet)
    })
  }
  ngAfterViewInit(): void {
    if (this.addressStreet) {
      this.addressStreet.ariaAutoComplete = "argh!!"
    }
    this.dt2.selectAllChange.subscribe(x => { console.info("event from select all ", x) })
  }

  buildStartDate() {
    let toDay = new Date();
    return new Date(toDay.getFullYear(), toDay.getMonth() - 1, toDay.getDate());
  }

  //#region OrdreForm
  resetOrdreForm() {
    this.orderForm.reset();
  }

  DateChange(event: any) {
    this.orderForm.controls.deliveryDate.setValue(event.event);
  }
  // this compines both backend autocomp and new KDS (replacment for DAWA)
  searchAddress(event: any) {
    const search = event.query?.trim();
    if (!search) {
      this.addressSearchSubscription?.unsubscribe();
      this.foundAddresses = [];
      return;
    }
    this.addressSearchSubscription?.unsubscribe();
    this.addressSearchSubscription = forkJoin({
      api: this.addressService.autoCompleteAddress(search) // backend autocomplte
        .pipe(catchError(error => {
          return of({ items: [] } as any);
        })
        ),

      kds: this.addressService.KdsAutocomplete(search)
    })
      .subscribe({
        next: ({ api, kds }) => {
          let addresses = [...kds, ...(api?.items ?? [])];
          let prioritized = [...addresses.filter(x => x.validatedBy === 'MongoDB'), ...addresses.filter(x => x.validatedBy !== 'MongoDB')];
          let seen = new Set<string>();

          this.foundAddresses = prioritized.filter(address => {
            let key = [address.street, address.houseNumber, address.postalCode].map(x => String(x ?? '').trim().toLowerCase()).join('|');

            if (seen.has(key)) return false;

            seen.add(key);
            return true;
          });
        },

        error: error => {
          console.error('Address search failed', error);
          this.foundAddresses = [];
        }
      });
  }


  searchAddress_old(event: any) {
    this.addressService.autoCompleteAddress(event.query).subscribe((addressResult: any) => {
      if (addressResult && addressResult.items) {
        this.foundAddresses = addressResult.items;
      }
    });
  }

  formattedStreetName(item: Address) {
    // If Address is chosen (Auto Complete)
    if (item && item.street) {
      return `${item.street}`;
    }
    // if Address is manually typed
    if (item) {
      return `${item}`;
    }
    return '';
  }

  setAddress(event: IAdressObject) {
    this.SelectedAdresseObject.patchValue({
      city: event.city,
      zipCode: event.zipCode,
      street: event.street,
      countryCode: event.countryCode,
      latitude: event.latitude,
      longitude: event.longitude
    });
    this.adresseForm.setValue(event);

    // this.SelectedAdresseObject.controls.city.setValue(event.city);
    // this.SelectedAdresseObject.controls.zipCode.setValue(event.zipCode);
    // this.SelectedAdresseObject.controls.street.setValue(event.street);
    // this.SelectedAdresseObject.controls.countryCode.setValue(event.countryCode);

  }

  CreateOrderFromFormGroups() {
    let request: CreateOrdreRequest = {
      clientId: null,
      deliveryCity: this.SelectedAdresseObject.controls.city.value,
      deliveryContactEmail: this.deliveryInfomationFormGroup.controls.deliveryContactEmail.value,
      deliveryContactPerson: this.deliveryInfomationFormGroup.controls.deliveryContactPerson.value,
      orderDate: new Date(),
      direction: Direction.Out,
      status: Statuses.new,
      deliveryContactPhone: this.deliveryInfomationFormGroup.controls.deliveryContactPhone.value,
      deliveryCountryCode: this.SelectedAdresseObject.value.countryCode,
      deliveryDate: this.orderForm.controls.deliveryDate.value,
      deliveryName: this.orderForm.controls.customerObject.value.name,
      deliveryNote: this.orderForm.controls.note.value,
      deliveryOrderNo: this.orderForm.controls.orderNumber.value,
      id: null,
      deliveryStreet: this.SelectedAdresseObject.controls.street.value,
      refference: this.orderForm.controls.orderNumber.value, // this field is used to give customer a way to write orderNo / ref
      deliveryZipCode: this.SelectedAdresseObject.controls.zipCode.value,
      orderLines: new Array<IOrderLinesCreateOrder>(),
      orderServices: new Array<OrderServices>()
    }
    this.selectedProducts.forEach(x => {
      let temp: IOrderLinesCreateOrder = {
        Amount: "1",
        AmountOnPallet: x.changeAmountOnPallet,
        ItemStockId: x.id,
        ItemId: x.itemId,
        Barcode: "",
        BatchNo: "",
        Note: ""
      }
      request.orderLines.push(temp);
    })

    this.warehouseService.CreateOrder(request);
    this.ref.close()
  }
  //#endregion

  //#region itemStocks
  ItemSelected(itemId: any) {

    this.warehouseService.GetItemStockDetails(itemId.id, true)
  }

  showSelectedItems() {
    this.IsShowSelectedItems = !this.IsShowSelectedItems;
  }
  //#endregion

  //#region customer auto
  searchCustomer(event: any) {
    this.customerService.searchCustomerFormatted(event.query).subscribe(
      (result: any) => {
        if (result) {
          this.foundCustomers = result;
        }
      },
      (error: any) => {
        this.foundCustomers = [];
      }
    );
  }

  setCustomer(cust: any) {

    // adresse
    let custAddrese = cust.address;
    this.SelectedAdresseObject.controls.customerObject.setValue(cust);
    this.SelectedAdresseObject.controls.city.setValue(custAddrese.city);
    this.SelectedAdresseObject.controls.countryCode.setValue(custAddrese.countryCode);
    this.SelectedAdresseObject.controls.latitude.setValue(custAddrese.latitude);
    this.SelectedAdresseObject.controls.longitude.setValue(custAddrese.longitude);
    this.SelectedAdresseObject.controls.street.setValue(custAddrese.street);
    this.SelectedAdresseObject.controls.zipCode.setValue(custAddrese.zipCode);
    this.orderForm.controls.CustomerName.setValue(custAddrese.name)
    if (cust && cust.contactPersons && cust.contactPersons.length > 0) {
      let contactPerson = cust.contactPersons[0];
      this.deliveryInfomationFormGroup.controls.deliveryContactEmail.setValue(contactPerson.email);
      this.deliveryInfomationFormGroup.controls.deliveryName.setValue(contactPerson.name);
      this.deliveryInfomationFormGroup.controls.deliveryContactPerson.setValue(contactPerson.name);
      this.deliveryInfomationFormGroup.controls.deliveryContactPhone.setValue(contactPerson.phone);
    }
    this.setAddress({
      city: custAddrese.city,
      countryCode: custAddrese.countryCode,
      latitude: custAddrese.latitude,
      longitude: custAddrese.longitude,
      street: custAddrese.street,
      zipCode: custAddrese.zipCode,
      validatedBy: custAddrese.validatedBy
    } as IAdressObject)

  }

  ClearCustomerObject() {
    this.SelectedAdresseObject.controls.customerObject.reset();
    this.SelectedAdresseObject.controls.city.reset();
    this.SelectedAdresseObject.controls.countryCode.reset();
    this.SelectedAdresseObject.controls.latitude.reset();
    this.SelectedAdresseObject.controls.longitude.reset();
    this.SelectedAdresseObject.controls.street.reset();
    this.SelectedAdresseObject.controls.zipCode.reset();
    this.orderForm.controls.catalogItem.setValue("");
    this.orderForm.controls.CustomerName.reset()
    this.deliveryInfomationFormGroup.controls.deliveryContactEmail.reset();
    this.deliveryInfomationFormGroup.controls.deliveryContactPerson.reset();
    this.deliveryInfomationFormGroup.controls.deliveryName.reset();
    this.deliveryInfomationFormGroup.controls.deliveryContactPhone.reset();
    this.orderForm.updateValueAndValidity();

  }
  //#endregion

  DateChangeEvent(value: Date, controll: FormControl<Date>) {
    controll.setValue(value);
  }

  RepalceNullDate() {
    return new Date();
  }

  stepperTestFunction(value: any) {
  }

  AutoMarkItemStocks(value: any, dataTable: any) {
    if (!isNaN(Number.parseInt(value)) && this.orderForm.controls.catalogItem.value) {
      this.selectedProducts = this.itemStockDetails$.value.slice(0, value);
    }
  }

  CheckForMaxAmount(event: itemStockDetails, value: any) {
    if (value == "")
      return;
    if (value > event.amountOnPallet) {
      event.changeAmountOnPallet = event.amountOnPallet;
    }
    else
      event.changeAmountOnPallet = value;
  }

  searchItemStocks(event: any) {
    const query = event.query?.toLowerCase() ?? '';
    const items = this.itemStocks$.value ?? [];

    this.filteredItemStocks = items.filter(item =>
      item.itemCode?.toLowerCase().includes(query) ||
      item.itemName?.toLowerCase().includes(query)
    );
  }
}


export interface IAdressObject {
  city: string;
  countryCode: string;
  latitude: number;
  longitude: number;
  street: string;
  validatedBy: string;
  zipCode: string;
}